<div class="route-itinerary-header">
  <div class="information">
    <div>{{ itinerary.totalTaskMiles }} Miles</div>
    <div>{{ itinerary.totalTime | minutesToHoursMinutes : 15 }}</div>
    <div *ngIf="transportCostDisplay">
      {{ transportCostDisplay }}
    </div>
  </div>
  <div class="pill-container">
    <extender-tag *ngIf="isExtension"></extender-tag>

    <carryover-tag
      *ngIf="itinerary.hasCarryOver"
      [count]="itinerary.carryOverCount"
    ></carryover-tag>

    <ev-tag *ngIf="itinerary.hasElectricVehicle" [count]="itinerary.electricVehicleCount"></ev-tag>

    <grab-bonus-badge
      *ngIf="itinerary.grabBonus?.bonusCount > 0"
      [count]="itinerary.grabBonus.bonusCount"
    ></grab-bonus-badge>

    <bike-tag *ngIf="itinerary.hasBikeRide" [count]="itinerary.bikeRideCount"> </bike-tag>
  </div>
</div>
